import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MD_HM_Review = () => {

  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [empId, setEmpId] = useState('');
  const [empIds, setEmpIds] = useState([]);
  const [empKPIData, setEmpKPIData] = useState([]);

  const [mdEntry, setMDEntry] = useState(false);
  const [hmEntry, setHMEntry] = useState(false);

  useEffect(() => {

    loadMyTeamMembers();

  }, []);

  const loadMyTeamMembers = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/ddl_Self_Team`);

      if (response.data && response.data.length > 0) {
        setEmpIds(response.data);
      }

      const resp_emptype = await axios.get(`${BASE_URL}/api/get_emp_type`);

      if (resp_emptype.data.length > 0) {
        if (resp_emptype.data[0].emp_type === 'MD') {
          setMDEntry(true);
          setHMEntry(true);
        } else if (resp_emptype.data[0].emp_type === 'HM') {
          setMDEntry(false);
          setHMEntry(true);
        }

      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  };

  const handleGetData = async () => {

    if (fromDate > toDate) {
      toast.error("From Date cannot be greater than To Date");
      return;
    } else if (empId === '') {
      toast.error("Please select Employee ");
      return;
    }

    try {
      setEmpKPIData([]);
      const res = await axios.get(`${BASE_URL}/api/rpt_Emp_Daily_KPI_Entry`, {
        params: {
          p_Emp_Id: empId,
          p_From_Date: fromDate,
          p_To_Date: toDate
        }
      });

      if (res.data.length > 0) {
        setEmpKPIData(res.data);
      } else {
        setEmpKPIData([]);
        toast.error("No Records Found");
      }
    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }
  };

  const formatDate = (dateStr) => {

    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;

  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  const getRatingLabel = (rating) => {

    const score = Number(rating);

    if (score >= 8)
      return { color: "green", icon: "🟢", text: "Excellent" };

    if (score >= 6)
      return { color: "#0056b3", icon: "🔵", text: "Very Good" };

    if (score >= 5)
      return { color: "#d4a017", icon: "🟡", text: "Very Good" };

    if (score >= 4)
      return { color: "orange", icon: "🟠", text: "Good" };

    if (score >= 3)
      return { color: "red", icon: "🔴", text: "Needs Improvement" };

    return { color: "black", icon: "⚫", text: "Poor" };

  };

  const handleReviewChange = (idx, field, value) => {

    const updatedData = [...empKPIData];

    updatedData[idx][field] = value;

    setEmpKPIData(updatedData);

  };

  const handleSave = async () => {

    const hasText = (value) =>
      value !== null &&
      value !== undefined &&
      String(value).trim() !== "";

    const hasRating = (value) =>
      value !== null &&
      value !== undefined &&
      String(value).trim() !== "";

    const invalidRow = empKPIData.find(row =>
      (hasText(row.hm_rem) && !hasRating(row.hm_rating)) ||
      (hasText(row.md_rem) && !hasRating(row.md_rating))
    );

    if (invalidRow) {
      toast.error("Please enter Rating before entering Remarks.");
      return;
    }

    const detailsToSave = empKPIData.filter(row =>
      hasRating(row.hm_rating) ||
      hasRating(row.md_rating)
    );

    if (detailsToSave.length === 0) {
      //toast.warning("Please enter at least one Director/HM rating or remark.");
      toast.error("Please enter at least one Director/HM rating or remark.");
      return;
    }

    if (!window.confirm("Sure you want to Update the inputs ?")) {
      return;
    }

    try {

      const lv_md_entry = mdEntry ? "Y" : "N";

      const response = await axios.post(`${BASE_URL}/api/save_MD_HM_Review`, {
        p_emp_id: empId, p_md_Entry: lv_md_entry,
        detailsData: detailsToSave
      });

      if (response.data.message === '1') {
        toast.success("Employee KPI updated successfully");
        setEmpKPIData([]);
      }

    } catch (err) {
      console.error(err);
      toast.error("Error updating Employee KPI");
    }

  };

  const options_emp = empIds.map(code => ({
    value: code.emp_id,
    label: code.emp_name
  }));

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>From Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>To Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={6} className="d-flex justify-content-end">

            <Button variant="primary" onClick={handleGetData} className="ms-2">
              Get Data
            </Button>          

            <Button variant="primary" className="ms-2"
              disabled={empKPIData.length === 0}
              > Clear
            </Button>
            <Button variant="success" className="ms-2"
              onClick={handleSave}
              disabled={empKPIData.length === 0}>
              Save
            </Button>
          </Col>
        </Row>

        <Row className="mt-3">

          <Col md={6}>

            <Select name="emp_id"
              options={options_emp}
              value={options_emp.find(option => String(option.value) === String(empId)) || null}
              //onChange={selectedOption => setEmpId(selectedOption.value)}
              onChange={(selectedOption) => {
                setEmpId(selectedOption.value);
                setEmpKPIData([]); // 👈 reset data here
              }}
              placeholder=" -- Select Team Member -- "
            />
          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table  hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '4%', color: 'black' }}>#</th>
                {/* <th>Notice Type</th> */}
                <th style={{ textAlign: 'left', width: '7%', color: 'black' }} >Entry Date </th>
                <th style={{ textAlign: 'left', width: '20%', color: 'black' }} >KPI Name <br/> Emp Remarks </th>
                <th style={{ textAlign: 'left', width: '8%', color: 'black' }} >Freq</th>
                {/* <th style={{ textAlign: 'left', width: '25%' }} >Emp Remarks</th> */}
                <th style={{ textAlign: 'left', width: '20%', color: 'black' }} >Supervisor Rating <br/> Remarks</th>
                <th style={{ textAlign: 'left', width: '20%', color: 'black' }} >HM Rating <br/>  Remarks</th>
                <th style={{ textAlign: 'left', width: '24%', color: 'black' }} >Director Rating <br/> Remarks</th>
                {/* <th style={{ textAlign: 'right', width: '8%' }} ></th> */}
              </tr>
            </thead>
            <tbody>
              {empKPIData.length > 0 ? (
                empKPIData.map((n, idx) => {
                  const ratingInfo = getRatingLabel(n.sup_rating);

                  return (
                    <tr key={n.entry_irn}>
                      <td style={{ textAlign: 'center' }}>{idx + 1}</td>

                      <td style={{ textAlign: 'left' }}> {n.entry_date} </td>

                      <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                       🎯<strong>KPI :</strong> {n.kpi_name} <br />
                       👤<strong>Emp Remarks :</strong> <span style={{ color: 'green' }}>
                          {n.emp_remarks}
                        </span>
                      </td>

                      <td style={{ textAlign: 'left' }}> {n.freq_desc} </td>

                      <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                        <span style={{ color: 'maroon' }}>
                          <b>Rating:</b>{" "}
                          <span style={{ color: ratingInfo.color }}>
                            {ratingInfo.icon} {n.sup_rating}
                          </span>
                        </span>
                        <br /> {n.sup_rem}
                      </td>
 {/* placeholder="HM Ranking" */}
                      <td style={{ height: "35px", textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                        <input type="number" className="form-control mb-2" 
                          style={{ textAlign: "right" }} value={n.hm_rating || ""}
                          disabled={mdEntry} min="0" max="10"
                          onChange={(e) => {
                            const value = e.target.value;
                            // allow empty
                            if (value === "") { 
                              handleReviewChange(idx, "hm_rating", "");
                              return;
                            }
                            const num = Number(value);
                            if (num >= 0 && num <= 10) {
                              handleReviewChange(idx, "hm_rating", value);
                            }
                          }} />
                        <textarea className="form-control"
                          rows="2" value={n.hm_rem || ""}
                          disabled={mdEntry} onChange={(e) => handleReviewChange(idx, "hm_rem", e.target.value) } />
                      </td>

                      <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                        <input type="number" className="form-control mb-2" style={{ textAlign: "right" }}
                           value={n.md_rating || ""} disabled={!mdEntry}
                           min="0" max="10"
                          onChange={(e) => {
                            const value = e.target.value;
                            // allow empty
                            if (value === "") { 
                              handleReviewChange(idx, "md_rating", "");
                              return;
                            }
                            const num = Number(value);
                            if (num >= 0 && num <= 10) {
                              handleReviewChange(idx, "md_rating", value);
                            }
                          }} />

                        <textarea className="form-control"
                          rows="2" value={n.md_rem || ""} disabled={!mdEntry}
                          onChange={(e) => handleReviewChange(idx, "md_rem", e.target.value) } />
                      </td>

                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody>

            {/* <tbody>

              {empKPIData.length > 0 ? (
                empKPIData.map((n, idx) => 
                  
                  (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'center' }} >{idx + 1}</td>
                    <td style={{ textAlign: 'left' }}> {n.entry_date} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                      {n.kpi_name} <br/>  
                        <span style={{ color: 'darkblue' }}> {n.emp_remarks} </span> 
                    </td>
                    <td style={{ textAlign: 'left' }}> {n.freq_desc} </td>
                     const ratingInfo = getRatingLabel(n.sup_rating);
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                      <span style={{ color: 'maroon' }}>
                        <b>Rating:</b>{" "}
                        <span style={{ color: ratingInfo.color }}>
                          {ratingInfo.icon} {n.sup_rating}
                        </span>
                      </span>
                      <br />

                      {n.sup_rem}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody> */}

          </table>
        </div>
      </Card>

    </Container>
  );
};

export default MD_HM_Review;
